import { MainTemplate } from "@/components/templates";
import {
  ProvisionalRegistrationForm,
  ProvisionalRegistrationFormValues,
} from "@/components/organisms";
import {
  RegisterProvisionalCompanyUserMutation,
  useRegisterProvisionalCompanyUserMutation,
} from "@/generated/graphql";
import React from "react";
import { useRouter } from "next/router";
import { PageTitle } from "@/components/molecules";
import useRollbarUtil from "../hooks/useRollbarUtil";

export const ProvisionalRegistrationPage = () => {
  const { getNotifyErrorHandlerForGraphQL } = useRollbarUtil();
  const router = useRouter();
  const { app } = router.query;

  const [registerProvisionalCompanyUserMutation] =
    useRegisterProvisionalCompanyUserMutation({
      onCompleted: (data: RegisterProvisionalCompanyUserMutation) => {
        if (data.registerProvisionalCompanyUser) {
          router.push("/provisional-registration-result");
        }
      },
      onError: getNotifyErrorHandlerForGraphQL(
        "Faild to register provisional company user",
        "登録に失敗しました"
      ),
    });

  const handleSubmit = async (
    formValues: ProvisionalRegistrationFormValues
  ) => {
    await registerProvisionalCompanyUserMutation({
      variables: {
        input: {
          email: formValues.email,
          app: app ? String(app) : "",
        },
      },
    });
  };

  return (
    <MainTemplate title="新規登録">
      <PageTitle
        mainTitle={`新規登録`}
        subTitle={
          <>
            Mikatano シリーズの各サービスに共通でログインできるMikatano
            IDを作成します。
            <br />
            メールアドレスを入力し利用規約に同意して登録してください。
          </>
        }
      />
      <ProvisionalRegistrationForm onSubmit={handleSubmit} />
    </MainTemplate>
  );
};
